
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface SupplementStepProps {
  formData: {
    currentSupplements: string;
    supplementGoals: string;
  };
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function SupplementStep({ 
  formData, 
  handleInputChange 
}: SupplementStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="currentSupplements">Current Supplements</Label>
        <Textarea
          id="currentSupplements"
          name="currentSupplements"
          value={formData.currentSupplements}
          onChange={handleInputChange}
          placeholder="List any supplements you currently take (vitamins, minerals, herbs, protein, etc.)"
          className="resize-none h-32"
        />
      </div>

      <div>
        <Label htmlFor="supplementGoals">Supplement Goals</Label>
        <Textarea
          id="supplementGoals"
          name="supplementGoals"
          value={formData.supplementGoals}
          onChange={handleInputChange}
          placeholder="What do you hope to achieve with supplements? (e.g., more energy, better sleep, muscle growth, etc.)"
          className="resize-none h-32"
        />
      </div>
    </div>
  );
}
